import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ActivityInfo, Chatroom } from '../../models';
import { getActivityInfo, getChatrooms } from '../../utils';
import Spinner from '../../share/Spinner';
import { useTranslation } from 'react-i18next';

export default function ManageContainer() {
  const [t] = useTranslation(['chatroom']);
  document.title = t('activity_manage', '活動管理');
  const params = useParams();
  const roomId = params.id;
  const room = useChatroom(roomId);
  const activityInfo = useActivityInfo(room);

  return room && activityInfo ? (
    <Outlet context={{ activityInfo, room }} />
  ) : (
    <Spinner />
  );
}

function useActivityInfo(room: Chatroom) {
  const [activityInfo, setActivityInfo] = useState<ActivityInfo>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!room) {
      return;
    }

    getActivityInfo(room)
      .then((response) => {
        setActivityInfo(response.data);
      })
      .catch((error) => {
        console.error(error.message);
        navigate('/', { replace: true });
      });
  }, [room, navigate]);

  return activityInfo;
}

function useChatroom(roomId: string | undefined) {
  const location = useLocation();
  const [room, setRoom] = useState<Chatroom>(location.state?.room);
  const navigate = useNavigate();

  useEffect(() => {
    if (room) {
      return;
    }

    getChatrooms()
      .then((rooms) => {
        const room = rooms.find((r) => r.id === roomId);
        if (!room) {
          throw new Error(`Room for id ${roomId} not found`);
        }

        setRoom(room);
      })
      .catch((error) => {
        console.error(error.message);
        navigate('/', { replace: true });
      });
  }, [navigate, room, roomId]);

  return room;
}
